import ko from 'knockout';
import { adGroupTypeEnum, adGroupTypeText } from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/adGroupTypeEnum';

export default class View {
  constructor() {
    this.adGroupType = ko.observable(adGroupTypeEnum.SearchStandard);

    this.adGroupTypeOptions = [
      { value: adGroupTypeEnum.SearchStandard, text: adGroupTypeText.SearchStandard },
      { value: adGroupTypeEnum.SearchDynamic, text: adGroupTypeText.SearchDynamic },
    ];

    this.showStandardAdGroupCreation = ko.computed(() => this.adGroupType() === adGroupTypeEnum.SearchStandard);
    this.showDynamicAdGroupCreation = ko.computed(() => this.adGroupType() === adGroupTypeEnum.SearchDynamic);
    this.hasDisclaimerSetting = ko.observable(false);
    this.errors = ko.observable([]);
  }
}
